import { customElement, query } from 'lit/decorators.js';
import { BaseCommerceCta } from '@themaven-net/commerce-published-webcomponents';

import './styles.scss';
import { renderCommerceLink } from '../../lib/commerceUtil';

@customElement('phoenix-commerce-cta')
export default class PhoenixCommerceCta extends BaseCommerceCta {
    protected override renderLink = renderCommerceLink;
    protected override defaultLinkClasses = 'm-product-offers--buy-button m-button is-inverted';

    @query('.m-commerce-cta--button.appendTarget')
    protected override appendTarget: Node | undefined;
}
